/* eslint-disable import/no-unresolved */
import { Login } from "../features/users/login";
import { Dashboard } from "../features/dashboard";
import { AddBusiness } from "../features/manageBusiness/add-business"
import { ManageBusiness } from "../features/manageBusiness/manage-business"
import { List as ListPartners } from "../features/shoppingPartners/list";
import { Add as AddPartners} from "../features/shoppingPartners/add";
import { ProductsList } from "../features/products/list";
import { AddProducts } from "../features/products/add";
import { SideNav } from "../components/admin/side-nav";
import { List as UsersList } from "../features/users/list";
import { List as AttendancesList } from "../features/attendances/list";
import { RolesList } from "../features/roles/roles-list";
import { AddRoles } from "../features/roles/add-roles";
import { AddUser } from "../features/users/addUser";
import {AddBeat}  from "../features/beats/add";
import { List as BeatList }  from "../features/beats/list";
import { List as LeaveRequestList } from "../features/leaves";
import { List as OrderList } from "../features/orders/list";
import { View as ViewOrder } from "../features/orders/view";
import  { ChangePass } from "../features/changePassword/change-pass";
import { CreateScheme, SchemeList } from "../features/scheme";
import { CreateOrder } from "../features/orders/createOrder";
import { StockLsit } from "../features/stock";
const Routes = {
  Login,
  Dashboard,
  AddBusiness,
  ManageBusiness,
  ListPartners,
  AddPartners,
  SideNav,
  ProductsList,
  AddProducts,
  UsersList,
  AttendancesList,
  RolesList,
  AddRoles,
  AddUser,
  AddBeat,
  BeatList,
  LeaveRequestList,
  OrderList,
  ViewOrder,
  ChangePass,
  CreateScheme,
  SchemeList,
  CreateOrder,
  StockLsit
}
export default Routes;
